import React from 'react';

import { SaveMetaInspectionForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';

export type SaveMetaInspectionModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveMetaInspectionModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save meta inspection'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveMetaInspectionForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
